/*
 * BottomBarMenu
 * @module components
 * @flow weak
 */

import React from 'react';
import { compose, lifecycle, withProps, withStateHandlers } from 'recompose';

import { BottomBarMenu as BBM } from './BottomBarMenu';

const enhance = compose(
  // $FlowIssue
  withProps({
    menuRef: React.createRef(),
  }),
  withStateHandlers(
    {
      isVisible: false,
    },
    {
      onButtonTouch: ({ isVisible }) => () => ({
        isVisible: !isVisible,
      }),
      onOutsideTouch: (state, { menuRef }) => e => {
        const { current } = menuRef;

        if (!e || !current || current.contains(e.target)) {
          return;
        }

        return {
          isVisible: false,
        };
      },
    },
  ),
  lifecycle({
    componentDidMount() {
      window.addEventListener('touchstart', this.props.onOutsideTouch);
    },
    componentWillUnmount() {
      window.removeEventListener('touchstart', this.props.onOutsideTouch);
    },
  }),
);

export const BottomBarMenu = enhance(BBM);
